const roundToPrecision = (number, precision, nullCheck = false) => {
    if (number === null && nullCheck) return null;
    const factor = 10 ** precision;
    const tempNumber = number * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
};

export default roundToPrecision;
